import { render, staticRenderFns } from "./BrowserIdentifierHandler.vue?vue&type=template&id=6f7e79a1&"
import script from "./BrowserIdentifierHandler.vue?vue&type=script&lang=js&"
export * from "./BrowserIdentifierHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports